import callBackend from '../shared/methods/callBackend/callBackend';

const deleteLocation = async (locationId) => callBackend({
  url: `${process.env.REACT_APP_API_URL}/transport/locations/${locationId}`,
  method: 'DELETE',
});

export default deleteLocation;
